<template>
  <div
    class="section section1"
    :style="{ 'background-image': `url('${bgPoster}')` }"
  >
    <div class="section-con">
      <img
        :src="emptyImage"
        class="fullpage-item-holder"
        style="display: inline;"
      />
      <div class="content-pos">
        <video-bg :src="bgSrc" :poster="bgPoster"></video-bg>
        <nav-bar @moveTo="moveTo"></nav-bar>
        <a
          href="//ffbewotv.seayoo.com/fft-m/index.html"
          class="fft up-ani"
          target="_blank"
        >
          <img :src="fftSrc" />
        </a>
        <div class="content">
          <span class="logo up-ani"></span>
          <div class="video-btn-box up-ani">
            <button class="video-btn" @click="showVideo"></button>
          </div>
          <div v-if="sloganUrl" class="up-ani">
            <span class="slogan">
              <img :src="sloganUrl" />
            </span>
          </div>
          <div class="opers up-ani">
            <img :src="down.spQr" class="qr-img" />
            <div class="btns">
              <button class="down-btn and-btn" @click="downFun('and')">
                Android下载
              </button>
              <button class="down-btn ios-btn" @click="downFun('ios')">
                iOS下载
              </button>
            </div>
            <div class="opers-btns">
              <button class="pc-btn" @click="downFun('pc')">pc下载</button>
              <button class="dw-btn" @click="downFun('dw')">点击秒玩</button>
            </div>
          </div>
        </div>
        <share-bar></share-bar>
      </div>
    </div>
    <video-player></video-player>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import Common from "./Common";
import NavBar from "./Nav";
import ShareBar from "./ShareBar";
import VideoBg from "./VideoBg";
import { getEmptySVG } from "@/libs/svg";
import VideoPlayer from "@/components/VideoPlayer";
import utils from "@/libs/utils";
const _hmt = window._hmt;
export default {
  name: "Section1",
  components: {
    VideoBg,
    ShareBar,
    NavBar,
    VideoPlayer
  },
  mixins: [Common],
  data() {
    return {
      fftSrc: "",
      bgSrc: "",
      bgPoster: "",
      // audioUrl: "",
      videoUrl: "",
      sloganUrl: "",
      emptyImage: getEmptySVG(1920, 1080)
    };
  },
  computed: {
    ...mapState(["channel"])
  },
  mounted() {
    this.getConfig();
  },
  methods: {
    ...mapActions(["changeShowVideo"]),
    moveTo(page) {
      this.$emit("moveTo", page);
    },
    showVideo() {
      this.changeShowVideo({
        isShow: true,
        src: this.videoUrl
      });
      _hmt.push(["_trackEvent", "index", "showVideo", utils.checkOperaSys()]);
    }
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@import "../assets/css/mixin.less";
.section1 {
  position: relative;
  background-repeat: no-repeat;
  // background: url("~@/assets/images/bg_01.jpg") no-repeat center top / cover;
  background-position: center top;
  background-size: cover;
  .mixin_com(font-size, 12);
  .section-con {
    height: 100% !important;
  }
  .content {
    position: relative;
    max-width: 1920px;
    height: 100%;
    margin: 0 auto;
  }
  .logo {
    position: absolute;
    background:
      url("~@/assets/images/section1/logo.png") no-repeat center top /
      100%;
    .mixin_com(top, 9);
    .mixin_com(left, 30);
    .mixin_com(width, 279);
    .mixin_com(height, 228);
  }
  .fft {
    position: absolute;
    z-index: 1;
    .mixin_com(top, 66);
    .mixin_com(right, 40);
    .mixin_com(width, 357);
    .mixin_com(height, 129);
    img {
      width: 100%;
    }
  }
  .slogan {
    position: absolute;
    left: 50%;
    transform: translateX(-47.6%);
    animation-delay: 1.1s;
    .mixin_com(top, 548);
    .mixin_com(width, 1140);
    img {
      width: 100%;
    }
  }
  .video-btn-box {
    animation-delay: 0.9s;
  }
  .video-btn {
    position: absolute;
    left: 50%;
    cursor: pointer;
    background:
      url("~@/assets/images/section1/topplay.png") no-repeat center
      center / contain;
    animation: bounce 1.5s infinite ease-in-out;
    .mixin_com(top, 439);
    .mixin_com(width, 74);
    .mixin_com(height, 74);
    .mixin_com(margin-left, -37);
  }
  .qr-img {
    .mixin_com(width, 112);
    .mixin_com(height, 112);
  }
  .order-btn {
    position: absolute;
    left: 50%;
    display: block;
    background:
      url("~@/assets/images/section1/ljyy.png") no-repeat left top /
      100%;
    transition: all 0.3s;
    animation-delay: 1.2s;
    .mixin_com(top, 882);
    .mixin_com(width, 277);
    .mixin_com(height, 58);
    .mixin_com(margin-left, -122);
    &:hover {
      transform: scale(1.03);
    }
  }
  .opers {
    position: absolute;
    left: 50%;
    display: flex;
    animation-delay: 1.2s;
    .mixin_com(top, 746);
    .mixin_com(width, 560);
    .mixin_com(margin-left, -280);
    //  .mixin_com(width, 660);
    // .mixin_com(margin-left, -330);
  }
  .btns {
    .mixin_com(margin-left, 15);
    .mixin_com(margin-right, 15);
  }
  .down-btn {
    display: block;
    text-indent: -9999px;
    cursor: pointer;
    transition: all 0.3s;
    .mixin_com(width, 277);
    .mixin_com(height, 57);
    &:hover {
      transform: scale(1.03);
    }
  }
  .and-btn {
    background:
      url("~@/assets/images/section1/andbtn.png") no-repeat left top /
      100%;
  }
  .ios-btn {
    background:
      url("~@/assets/images/section1/iosbtn.png") no-repeat left top /
      100%;
  }
  .opers-btns {
    display: flex;
  }
  .pc-btn {
    .mixin_com(width, 113);
    .mixin_com(height, 113);

    text-indent: -9999px;
    cursor: pointer;
    background:
      url("~@/assets/images/section1/pcbtn.png") no-repeat left top /
      100%;
    box-shadow: 0 0 8px #0700025c;
    transition: all 0.3s;
    &:hover {
      transform: scale(1.03);
    }
  }
  .dw-btn {
    text-indent: -9999px;
    cursor: pointer;
    background:
      url("~@/assets/images/section1/dwbtn.png") no-repeat left top /
      100%;
    box-shadow: 0 0 8px #0700025c;
    transition: all 0.3s;
    .mixin_com(width, 113);
    .mixin_com(height, 113);
    .mixin_com(margin-left, 15);
    &:hover {
      transform: scale(1.03);
    }
  }
}
</style>
